export default function makeGetTableSelectRange(store) {
  return {
    getTableSelectRange: function getTableSelectRange(editor) {
      var tableId = store.getItem('lastFocusedTableId');

      var _ref = store.getItem(tableId) || {},
          startCell = _ref.startCell,
          endCell = _ref.endCell;

      return {
        startCell: startCell,
        endCell: endCell
      };
    }
  };
}